module.exports = __webpack_public_path__ + "img/q30-1.e893a0c4.jpg";